export const currentView_Group = "EG0F7";
export default {currentView_Group};